/**
 * MotoristaMensagemPushCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'

/* TODO: review generated class */
@HttpExclude()
export class MotoristaMensagemPushCollection extends PageCollection<
  MotoristaMensagemPush
> {
  constructor() {
    super(MotoristaMensagemPush)
  }

  queryAsPage() {
    return this.listMotoristaMensagemPush()
  }

  async listMotoristaMensagemPush() {
    return await Request.get(`/admin/motorista-mensagem-push`, {
      params: this.params,
    })
      .name('listMotoristaMensagemPush')
      .as(this)
      .getResponse()
  }

  async listCsvMotoristaMensagemPush() {
    return await Request.get(`/admin/motorista-mensagem-push/csv`, {
      params: this.params,
    })
      .name('listCsvMotoristaMensagemPush')
      .as(this)
      .getResponse()
  }
}
